import { QuestionnaireFrequency } from '@gcv/shared';
import { useMutation } from '@tanstack/react-query';

import { QuestionnairesApi } from 'api';
import { BANK_QUESTIONNAIRE_KEY } from '../../keys';
import { useUser } from '../../user';
import { useBankQuestionnaireCache } from '../useBankQuestionnaireCache';

export interface CloneQuestionnaireTemplateParams {
  name: string;
  description: string;
  templateId: string;
  frequency: QuestionnaireFrequency;
  timeToRespond: number;
  thresholdPercentage?: number;
}

export function useCloneQuestionnaireTemplate() {
  const { userBankId } = useUser();
  const { addQuestionnaire } = useBankQuestionnaireCache();
  const questionnairesApi = new QuestionnairesApi();

  const { mutateAsync: cloneQuestionnaireTemplate, isPending: isCloneQuestionnaireTemplatePending } =
    useMutation({
      mutationKey: [BANK_QUESTIONNAIRE_KEY],
      mutationFn: ({
        name,
        description,
        templateId,
        frequency,
        timeToRespond,
        thresholdPercentage
      }: CloneQuestionnaireTemplateParams) =>
        questionnairesApi.cloneQuestionnaireTemplate(userBankId, {
          name,
          description,
          template_id: templateId,
          schedule: {
            reoccurring: frequency !== QuestionnaireFrequency.Once,
            frequency,
            time_to_respond: timeToRespond,
            reminder: 2
          },
          ...(thresholdPercentage !== undefined && { threshold_percentage: thresholdPercentage })
        }),
      onSuccess: addQuestionnaire,
      meta: {
        snackbarErrorMessage: 'Could not create new questionnaire.'
      }
    });

  return { cloneQuestionnaireTemplate, isCloneQuestionnaireTemplatePending };
}
